import React, { Component } from 'react';
import { confirmDialog } from 'primereact/confirmdialog';

import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelCalendar } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import { buildRelacionados } from '../../../service/RotasService';

import TarefaAgendada           from '../../../models/TarefaAgendada';
import TarefaAgendadaStatusEnum from '../../../enums/TarefaAgendadaStatusEnum';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    id:   { exibir: 'main.id', tipo: 'numeric', largura: '5rem', fixar: true },
    nome: { exibir: 'main.tarefaagendada.nome', visivel: true },
    cron: { exibir: 'main.tarefaagendada.cron', visivel: true, fixar: true, largura: "7rem" },
    ativa: {
        exibir:   'main.tarefaagendada.ativa',
        visivel:  true,
        tipo:     'boolean',
        template: 'ativa.template',
        fixar: true,
        largura: "4rem"
    },
    dataultimaexecucao: { exibir: 'main.tarefaagendada.dataultimaexecucao', visivel: true, largura: '12rem', tipo: 'date', time: true, fixar: true },
    status: {
        exibir:   'main.tarefaagendada.status',
        visivel:  true,
        tipo:     'enum',
        entidade: 'tarefaagendada.status',
        fixar: true,
        largura: "7rem"
    },
    // Oculto na grid por padrao (disponivel no configurador) - mesmo padrao de campos "tecnicos"
    // ja usado em UsuarioLogTemplate/UsuarioSessaoTemplate (homologacao/tempologin/etc.).
    caminho: { exibir: 'main.tarefaagendada.caminho' },
    // id/updatedAt/createdAt sao injetados automaticamente pelo EntityGrid (mesclarCamposPadrao),
    // ja com largura: '10rem' - nao redeclarar aqui (ver JSDoc de EntityGrid.js).
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const booleanTemplate = (campo) => (rowData) => (
    <i className={`pi ${rowData[campo] ? 'pi-check text-green-500' : 'pi-times text-red-400'}`}></i>
);

const renderers = {
    ativa:                    { template: booleanTemplate('ativa') },
    'tarefaagendada.status':  TarefaAgendadaStatusEnum,
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

// Todos os campos sao preenchidos automaticamente pelo seed/provisionamento da publicacao (ver
// TarefaAgendada.dadosInciais/PublicacaoController.liberar) - nunca editaveis diretamente pelo
// admin, exceto `ativa`, que muda exclusivamente pelo processo de toolbar Ativar/Desativar.
class TarefaAgendadaFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <div className="grid">
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={{ ...model.nome, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={{ ...model.caminho, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={{ ...model.cron, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelBoolean model={{ ...model.ativa, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={{ ...model.status, disabled: true }} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelCalendar model={{ ...model.dataultimaexecucao, disabled: true }} contexto={contexto} />
                </div>
            </div>
        );
    }
}

// ─── Template (componente exportado) ──────────────────────────────────────────

class TarefaAgendadaTemplate extends Component {

    processos() {
        const { permissoes } = this.props;
        const t = (chave) => UtilService.traduzir(chave);
        const lista = [];

        const podeAtivar = permissoes?.tarefaagendada?.processos?.some(
            (e) => e.state === 'main.tarefaagendada.ativar' && e.permitido,
        );
        const podeDesativar = permissoes?.tarefaagendada?.processos?.some(
            (e) => e.state === 'main.tarefaagendada.desativar' && e.permitido,
        );
        if (podeAtivar || podeDesativar) {
            lista.push({
                label: 'main.tarefaagendada.ativar',
                icon:  'pi pi-power-off',
                disabled: true,
                ativo: (processo, selected) => {
                    const row = selected?.[0];
                    processo.disabled = selected.length !== 1;
                    if (row?.ativa) {
                        processo.label = 'main.tarefaagendada.desativar';
                        processo.icon = 'pi pi-power-off text-red-500';
                    } else {
                        processo.label = 'main.tarefaagendada.ativar';
                        processo.icon = 'pi pi-power-off text-green-500';
                    }
                    return processo;
                },
                command: () => {
                    const row = this.gridRef?.getSelected()?.[0];
                    if (!row) return;
                    const ativando = !row.ativa;
                    const acao = ativando ? 'ativar' : 'desativar';
                    confirmDialog({
                        header:       t(`main.tarefaagendada.${acao}.confirmacao.header`),
                        message:      t(`main.tarefaagendada.${acao}.confirmacao.mensagem`),
                        icon:         'pi pi-exclamation-triangle',
                        className:    'w-4',
                        draggable:    false,
                        defaultFocus: 'reject',
                        acceptClassName: ativando ? 'p-button-success' : 'p-button-danger',
                        accept: async () => {
                            try {
                                await (ativando ? TarefaAgendada.ativar(row.id) : TarefaAgendada.desativar(row.id));
                                UtilService.showToast({ severity: 'success', summary: t(`main.tarefaagendada.${acao}.sucesso`) });
                            } catch {
                                UtilService.showToast({ severity: 'error', summary: t(`main.tarefaagendada.${acao}.erro`) });
                            }
                            await this.gridRef?.atualizar();
                        },
                    });
                },
            });
        }

        const podeExecutarAgora = permissoes?.tarefaagendada?.processos?.some(
            (e) => e.state === 'main.tarefaagendada.executaragora' && e.permitido,
        );
        if (podeExecutarAgora) {
            lista.push({
                label:    'main.tarefaagendada.executaragora',
                icon:     'pi pi-play',
                disabled: true,
                ativo: (processo, selected) => {
                    processo.disabled = selected.length !== 1;
                    return processo;
                },
                command: () => {
                    const row = this.gridRef?.getSelected()?.[0];
                    if (!row) return;
                    confirmDialog({
                        header:       t('main.tarefaagendada.executaragora.confirmacao.header'),
                        message:      t('main.tarefaagendada.executaragora.confirmacao.mensagem'),
                        icon:         'pi pi-exclamation-triangle',
                        className:    'w-4',
                        draggable:    false,
                        defaultFocus: 'reject',
                        acceptClassName: 'p-button-warning',
                        accept: async () => {
                            try {
                                const resultado = await TarefaAgendada.executarAgora(row.id);
                                if (resultado?.status && resultado.data?.status) {
                                    UtilService.showToast({ severity: 'success', summary: t('main.tarefaagendada.executaragora.sucesso') });
                                } else {
                                    UtilService.showToast({ severity: 'error', summary: t('main.tarefaagendada.executaragora.erro'), detail: resultado?.data?.mensagem });
                                }
                            } catch {
                                UtilService.showToast({ severity: 'error', summary: t('main.tarefaagendada.executaragora.erro') });
                            }
                            await this.gridRef?.atualizar();
                        },
                    });
                },
            });
        }

        return lista;
    }

    render() {
        return (
            <EntityGrid
                ref={(ref) => this.gridRef = ref}
                entidade={TarefaAgendada}
                model={model}
                identidade="main.tarefaagendada"
                permissoes={this.props.permissoes}
                icone="pi-history"
                storageKey="dt-tarefaagendadas"
                processos={this.processos()}
                getRelacionados={(selected) => buildRelacionados(
                    'tarefaagendada',
                    this.props.permissoes,
                    this.props.navigate,
                    () => selected?.[0],
                )}
                renderers={renderers}
                configuracao={this.props.configuracao}
                navigate={this.props.navigate}
                location={this.props.location}
                searchparams={this.props.searchparams}
                ordenacaoPadrao={{ sortField: 'dataultimaexecucao', sortOrder: -1 }}
                formulario={(m, ctx) => <TarefaAgendadaFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default TarefaAgendadaTemplate;
